import { FETCH_END } from 'actions/fetchActions';
import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
} from 'api/types';
import {CLEAR_CURD_RESOURCE_DATA, CHANGE_CURD_RESOURCE_DATA} from "actions";

const addRecords = (newRecords = []) => {
  return newRecords.reduce((prev, record) => {
    prev[record.id] = record; // eslint-disable-line no-param-reassign
    return prev;
  }, {});

};

const initialState = {};

export default resource => (previousState = initialState, { payload, meta, requestPayload }) => {
  if (!meta || meta.resource !== resource) {
    return previousState;
  }
  if (meta.isCustomRequest && meta.type === CLEAR_CURD_RESOURCE_DATA) {
    return initialState;
  }
  if (meta.isCustomRequest && meta.type === CHANGE_CURD_RESOURCE_DATA) {
    return payload.data;
  }
  if (!meta.fetchResponse || meta.fetchStatus !== FETCH_END) {
    return previousState;
  }
  switch (meta.fetchResponse) {
    case GET_LIST:
    case GET_MANY:
    case GET_MANY_REFERENCE:
      return addRecords(payload.data);
    case GET_ONE:
    case CREATE:
      return addRecords([payload.data]);
    case UPDATE:
      return addRecords([{...requestPayload.previousData, ...payload.data}]);
    default:
      return previousState;
  }
};

export const getRecord = (state, id) => state[id];



// WEBPACK FOOTER //
// ./src/reducers/resource/data.js